import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/SoraIcon.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              colors <span className="gradient-text"> gradually </span> painted into the sky
            </h1>
            <p className="home-about-body">
            hello i'm <span className="green"><u>gradual</u></span>! i program by day, build little projects by night.<br/> 
            
            <span className="green"><u>data analysis</u></span> and <span className="green"><u>coding</u></span> are hobbies that i enjoy. i also have a bias for my enstars ship subanatsuhokke.<br/><br/>
            <span className="green"><u>just a note</u></span>, i'm a pretty busy person so there may be times my posts might be late. <span className="green"><u>also, please do not ask me how i retrieved these files! i will not answer your question.</u></span><br/> <br/> <span className="green"><em><strong>it is to my digression if an asset drive has to be taken down, then i will temporarily lock and take it down.</strong></em></span>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="green">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/gradualcolors"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/gradualcolors"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
